import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Youtube } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import Newsletter from "@/components/public/Newsletter";

export default function Footer() {
  const { settings, categories } = useSite();
  const socials = settings.socials || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-sunset-ink text-white">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 pt-24 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <h3 className="font-serif text-3xl mb-4">{settings.site_name || "Sunset Magazine"}</h3>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              {settings.description || "Revista digital premium de cultura, viajes, gastronomía y estilo de vida."}
            </p>
            <div className="flex gap-4 mt-6">
              {socials.instagram && <a href={socials.instagram} aria-label="Instagram" className="text-white/60 hover:text-sunset-accent transition-colors"><Instagram size={20} /></a>}
              {socials.facebook && <a href={socials.facebook} aria-label="Facebook" className="text-white/60 hover:text-sunset-accent transition-colors"><Facebook size={20} /></a>}
              {socials.twitter && <a href={socials.twitter} aria-label="Twitter" className="text-white/60 hover:text-sunset-accent transition-colors"><Twitter size={20} /></a>}
              {socials.youtube && <a href={socials.youtube} aria-label="Youtube" className="text-white/60 hover:text-sunset-accent transition-colors"><Youtube size={20} /></a>}
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="kicker text-white/40 mb-5">Navegación</p>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/" className="hover:text-white transition-colors">Inicio</Link></li>
              <li><Link to="/articulos" className="hover:text-white transition-colors">Artículos</Link></li>
              <li><Link to="/revistas" className="hover:text-white transition-colors">Revistas</Link></li>
              <li><Link to="/nosotros" className="hover:text-white transition-colors">Nosotros</Link></li>
              <li><Link to="/contacto" className="hover:text-white transition-colors">Contacto</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="kicker text-white/40 mb-5">Categorías</p>
            <ul className="space-y-3 text-sm text-white/70">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}><Link to={`/categoria/${c.slug}`} className="hover:text-white transition-colors">{c.name}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="kicker text-white/40 mb-5">Newsletter</p>
            <Newsletter variant="footer" />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40">
          <p>© {year} {settings.footer_text || "Sunset Magazine RD"}</p>
          <div className="flex gap-6">
            <Link to="/nosotros" className="hover:text-white transition-colors">Política de Privacidad</Link>
            <Link to="/nosotros" className="hover:text-white transition-colors">Términos</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
